// extracted by css-extract-rspack-plugin
export default {"root":"hR_fXV"};